import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { DeploymentsClient, ShiftResponse } from '..';
import { LoadingDefaults } from '../models/loading-defaults.model';
import { RplLoadingService } from '../services/rpl-loading.service';

export const assignableShiftsResolver: ResolveFn<ShiftResponse[]> = () => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(RplLoadingService);

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getAssignableShifts().pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
